var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.show
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]) : _vm._e(), _vm.isDialogActiveLocal ? _c('confirm-action-dialog', {
    attrs: {
      "width": "800px",
      "title": _vm.$t('cost.createCost'),
      "isDialogActive": _vm.isDialogActiveLocal,
      "rightText": _vm.$t('create'),
      "loading": _vm.isLoading,
      "rightLoading": _vm.isLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActiveLocal = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActiveLocal = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.isDialogActive = false;
      },
      "close": function close($event) {
        _vm.isDialogActive = false;
      },
      "rightClick": _vm.onRightClick
    }
  }, [_c('v-row', {
    staticClass: "pt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.cost.title'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.cost.title,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "title", $$v);
      },
      expression: "cost.title"
    }
  }), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('objects.cost.description')
    },
    model: {
      value: _vm.cost.description,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "description", $$v);
      },
      expression: "cost.description"
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.cost.total,
      "type": "number",
      "outlined": "",
      "label": _vm.$t('objects.cost.total')
    },
    on: {
      "change": function change(total) {
        return _vm.cost.total = Number(total);
      }
    }
  }), _c('v-combobox', {
    attrs: {
      "items": _vm.tags,
      "label": _vm.$t('objects.cost.tags'),
      "multiple": "",
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', _vm._b({
          attrs: {
            "outlined": ""
          }
        }, 'v-chip', item.attrs, false), [_vm._v(" " + _vm._s(item) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item) + " ")])], 1)];
      }
    }], null, false, 1686412609),
    model: {
      value: _vm.cost.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "tags", $$v);
      },
      expression: "cost.tags"
    }
  }), _c('partner-pdfs', {
    attrs: {
      "partnerId": _vm.partnerId,
      "isMenu": false
    },
    model: {
      value: _vm.cost.files,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "files", $$v);
      },
      expression: "cost.files"
    }
  }), _c('v-select', {
    attrs: {
      "item-value": "id",
      "items": _vm.groups,
      "label": _vm.$t('objects.cost.group'),
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.title) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.title) + " ")];
      }
    }], null, false, 2714690748),
    model: {
      value: _vm.cost.group,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "group", $$v);
      },
      expression: "cost.group"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('refs-select', {
    attrs: {
      "partnerId": _vm.partnerId,
      "loading": _vm.isLoading,
      "suggested": _vm.suggested,
      "listMode": true,
      "hideEditButton": true,
      "categories": _vm.categories,
      "isConfirmable": false
    },
    on: {
      "change": _vm.onRefsChange
    },
    model: {
      value: _vm.cost.refs,
      callback: function callback($$v) {
        _vm.$set(_vm.cost, "refs", $$v);
      },
      expression: "cost.refs"
    }
  })], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }